import React from 'react';
import Typography from '@material-ui/core/Typography'
import {
    makeStyles,
  } from "@material-ui/core/styles";

const useStyles = makeStyles({
    ratingContainer: {
        backgroundColor: '#f5f5f5',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
    ratingHeader: {
        marginBottom: '15px',
    },
    ratingItem: {
        marginBottom: '10px',
    },
    optionList: {
        listStyle: 'none',
        paddingLeft: 0,
    },
    optionItem: {
        marginBottom: '5px',
    },
});


function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

const ExistingRating = ({ existingRating }) => {
    const classes = useStyles();

    return (
        existingRating && Object.keys(existingRating).length > 0 && (
            <div className={classes.ratingContainer}>
                <Typography variant="h6" className={classes.ratingHeader}>Previous Rating</Typography>
                {Object.keys(existingRating).map((key) => (
                    <div key={key} className={classes.ratingItem}>
                        <Typography variant="body2" gutterBottom>
                            {capitalizeFirstLetter(key)}:
                            {!Array.isArray(existingRating[key]) ? (
                                <span> {existingRating[key]}</span>
                            ) : (
                                <ul className={classes.optionList}>
                                    {existingRating[key].map((option) => (
                                        <li key={option.name} className={classes.optionItem}>
                                            <Typography variant="body2" gutterBottom>
                                                {capitalizeFirstLetter(option.name)}: {option.description}
                                            </Typography>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </Typography>
                    </div>
                ))}
            </div>
        )
    );
};

export default ExistingRating;
